module.exports = __webpack_public_path__ + "img/logo_r.4f9c192d.png";